import React, { useMemo } from 'react'
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, LinkedTo, Validation } from 'app/modules/tp/builders/FormBuilder';
import { deepWriteKeyObj, traverseArrayKeyObj, traverseKeyObj } from 'app/utils/keys';
import Datetime from 'react-datetime';
import 'moment/locale/it';
import { getParentKey } from './MultiplyField';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';

export type DateTimePickerInputObj<T> = {
    hoursRange?: boolean,
    dateRange?: boolean,
    type: "datetime_picker" | "date_picker" | "time_picker",
    key: keyof T,
    placeholder?: string,
    isRequired?: boolean,
    attributes?: Attributes
} & Attributes & Validation & Label & LinkedTo<T>


export type DateTimePickerFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: DateTimePickerInputObj<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}

export const dateFormat = 'DD/MM/YYYY'
export const timeFormat = 'HH:mm'

const DateTimePickerField = <T,>({ formik, inputObj, onChange }: DateTimePickerFieldProps<T>) => {

    const isRequiredField = (inputObj: DateTimePickerInputObj<T>) => {
        return inputObj.validation?.spec?.presence === 'required'
    }

    const onDateChange = (v: string | moment.Moment) => {
        let date = v;
        const format = inputObj.type === "datetime_picker" ?
            dateFormat + " " + timeFormat :
            (inputObj.type === "date_picker" ? dateFormat : timeFormat)
        if (typeof date !== "string") {
            date = date.format(format)
        }
        formik.setFieldValue(inputObj.key as string, date)
        onChange && onChange(formik.values)
    }

    //const value  = useMemo(() => (
    //    ((traverseArrayKeyObj(formik.values, inputObj.key as string) || "") as string || "") as string
    //), [formik.values, inputObj.key])

    React.useEffect(() => {
        if (!inputObj?.linkedTo) {
            return
        }
        const parentKey = getParentKey(inputObj.key as string);
        const linkedToKey = (`${parentKey}.${inputObj.linkedTo}`)
        const linkedMeta = formik.getFieldMeta(linkedToKey)
        const currentMeta = formik.getFieldMeta(inputObj.key as string)
        if (!currentMeta.value) {
                const linkedValue = linkedMeta?.value;
                if (linkedValue) {
                    formik.setFieldValue(inputObj.key as string, linkedValue)
                }
            }
        }, [formik.values])

    return (<>
        {inputObj.label && (
            <label className={`fw-bold fs-6 mb-2 ${isRequiredField(inputObj) ? "required" : ""} `}>
                {inputObj.label}
            </label>
        )}

        <Datetime
            utc
            locale='it'
            {...formik.getFieldProps(inputObj.key as string)}
            onChange={onDateChange}
            timeFormat={(inputObj.type === "datetime_picker" || inputObj.type === "time_picker") ? timeFormat : false}
            dateFormat={(inputObj.type === "datetime_picker" || inputObj.type === "date_picker") ? dateFormat : false}
            inputProps={{
                disabled: !!formik?.isSubmitting
            }}
        />
        {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
            <ErrorMessage name={inputObj.key as string}
                render={(error: string) => (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{error}</span>
                        </div>
                    </div>
                )} />
        )}

    </>
    )
}
export default DateTimePickerField;
